import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { textValue } from '../../utils/Helpers';
import { Row, Col } from 'reactstrap';
import { connect } from "react-redux";
import { doFilteringSearchToApi } from '../../actions/productAction'

class CheckboxBrands extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }

  render() {
    return (
      <div style={{ backgroundColor: "pink"}}>
        <div style={{ display: "flex", flex: 1, flexDirection: "row", margin: "0 15px 5px 15px", cursor: "pointer" }} onClick={() => this.props.onClick(this.props.value)}>
          <div style={{ flex: 0.1, padding: 0 }}>
            <div 
              style={{ 
                width: "15px", 
                height: "15px", 
                border: "1px solid #4a4a4a",
                borderRadius: "3px",
                backgroundColor: this.props.isActive ? "#e4e4e4" : "#fff" 
              }}>
            </div>
          </div>
          <div style={{ flex: 0.9, paddingRight: 0 }}>
            <p style={{ marginBottom: 0, textTransform: "capitalize" }}>{this.props.brandName}</p>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  dataProduct: state.dataProduct,
  dataFilter: state.filterReducer,
});
const mapDispatchToProps = {
  doFilteringSearchToApi
};

export default connect(mapStateToProps, mapDispatchToProps) (CheckboxBrands);